import React from "react";
import { Button } from "reactstrap";
import {
    FaCashRegister,
    FaUndo,
    FaMoneyBillWave,
    FaSignOutAlt,
    FaStore,
    FaArrowLeft
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { authActions } from "../../sagas/authSlice";

const POSHeader = ({
    businessName,
    fullName,
    isAdmin = false,
    activeTab = "VENTES",
    onChangeTab,
}) => {

    const tabs = [
        { key: "VENTES", label: "Ventes", icon: FaCashRegister, color: "primary" },
        { key: "AVANCE", label: "Paiements", icon: FaMoneyBillWave, color: "warning" },
        { key: "RETOURS", label: "Retours", icon: FaUndo, color: "info" },
    ];

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const handleLogout = () => {
        Swal.fire({
            title: t('auth.logoutConfirmTitle'),
            text: t('auth.logoutConfirmText'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('common.confirm'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(authActions.logout());
                Swal.fire({
                    icon: 'success',
                    title: t('auth.logoutSuccess'),
                    showConfirmButton: false,
                    timer: 1500
                }).then(() => {
                    navigate('/login');
                });
            }
        });
    };

    const handleBack = () => {
        navigate('/modules');
    };

    return (
        <div
            className="d-flex align-items-center justify-content-between px-4 py-2 mb-3 shadow-sm"
            style={{
                background: "#fff",
                borderRadius: 12,
                border: "1px solid #e5e7eb",
                position: "sticky",
                top: 0,
                zIndex: 1000,
            }}
        >
            {/* LEFT: Back + Business */}
            <div className="d-flex align-items-center gap-3">
                {isAdmin && (
                    <Button
                        color="light"
                        className="d-flex align-items-center p-2"
                        onClick={handleBack}
                        style={{
                            borderColor: "#e5e7eb",
                        }}
                    >
                        <FaArrowLeft className="text-primary" size={16} />
                    </Button>
                )}

                <FaStore size={24} className="text-primary" />

                <div>
                    <div className="fw-bold text-primary">{businessName}</div>
                    <small className="text-muted">Point de vente</small>
                </div>
            </div>

            {/* CENTER: Main Actions (Only non admin) */}
            <div className="d-flex align-items-center gap-2">
                {!isAdmin &&
                    tabs.map(tab => {
                        const Icon = tab.icon;
                        const active = activeTab === tab.key;

                        return (
                            <Button
                                key={tab.key}
                                color={active ? tab.color : "secondary"}
                                outline={!active}
                                className="d-flex align-items-center px-3 fw-bold"
                                onClick={() => onChangeTab(tab.key)}
                            >
                                <Icon className="me-2" />
                                {tab.label}
                            </Button>
                        );
                    })
                }
            </div>

            {/* RIGHT: User */}
            <div className="d-flex align-items-center gap-3">
                <span className="fw-semibold text-muted">{fullName}</span>
                <Button color="danger" size="sm" onClick={handleLogout}>
                    <FaSignOutAlt />
                </Button>
            </div>
        </div>
    );
};

export default POSHeader;
